import React, { useEffect } from 'react';
import { motion } from 'motion/react';
import { Box, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { modalOverlayVariants, modalContentVariants } from '../../animations/variants';

// `maxWidth` widens the panel for content that needs the room — the
// permission-set modals render indented IAM policy JSON, which wraps into an
// unreadable ribbon at the 600px default. Callers that pass nothing keep that
// default, so existing modals are unaffected.
const Modal = ({ children, onClose, maxWidth = '600px' }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) onClose();
    };
    window.addEventListener('keydown', handleEsc);

    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <motion.div
      variants={modalOverlayVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
        backgroundColor: 'rgba(37, 62, 102, 0.5)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <motion.div
        variants={modalContentVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          width: '90%',
          maxWidth,
          maxHeight: '90vh',
          overflowY: 'auto',
          backgroundColor: '#FFFFFF',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
        }}
      >
        <style>{`
          .modal-content-animated::-webkit-scrollbar { width: 6px; }
          .modal-content-animated::-webkit-scrollbar-track { background: #F9FBFD; border-radius: 3px; }
          .modal-content-animated::-webkit-scrollbar-thumb { background: #D9DBDC; border-radius: 3px; }
          .modal-content-animated::-webkit-scrollbar-thumb:hover { background: #BDBDBD; }
        `}</style>
        <div className="modal-content-animated" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
        {/* Close button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            backgroundColor: '#F9FBFD',
            color: '#666666',
            zIndex: 10,
            width: 32,
            height: 32,
            border: '1px solid #E5E5E5',
            '&:hover': {
              backgroundColor: '#F0F4F8',
              color: '#253E66',
            },
          }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>

        {/* Content */}
        <Box>
          {children}
        </Box>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Modal;
